import { useState, useEffect } from 'react';
import { Accessibility } from 'lucide-react';

export function AccessibilityButton() {
  const [isActive, setIsActive] = useState(() => {
    try {
      return localStorage.getItem('accessible-mode') === 'true';
    } catch {
      return false;
    }
  });
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    if (isActive) {
      document.body.classList.add('accessible-mode');
    } else {
      document.body.classList.remove('accessible-mode');
    }
    try {
      localStorage.setItem('accessible-mode', String(isActive));
    } catch {
      // localStorage not available
    }
  }, [isActive]);

  return (
    <div className="fixed top-20 right-4 z-40">
      <div className="relative">
        {/* Tooltip */}
        {showTooltip && (
          <div className="absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap bg-gray-900 text-white text-xs font-medium px-3 py-1.5 rounded-lg shadow-lg pointer-events-none">
            {isActive ? 'Akadálymentes mód kikapcsolása' : 'Akadálymentes mód bekapcsolása'}
            <div className="absolute left-full top-1/2 -translate-y-1/2 border-4 border-transparent border-l-gray-900" />
          </div>
        )}

        <button
          onClick={() => setIsActive((prev) => !prev)}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          aria-pressed={isActive}
          aria-label={
            isActive
              ? 'Akadálymentes mód kikapcsolása'
              : 'Akadálymentes mód bekapcsolása – nagyobb betűk, jobb kontraszt, szövegfelolvasóbarát'
          }
          data-testid="accessibility-btn"
          className={`w-11 h-11 rounded-full flex items-center justify-center shadow-lg transition-all duration-200 border-2 focus:outline-none focus:ring-4 focus:ring-orange-300 ${
            isActive
              ? 'bg-orange-500 border-orange-600 text-white scale-110'
              : 'bg-white border-gray-200 text-gray-600 hover:border-orange-400 hover:text-orange-500'
          }`}
        >
          <Accessibility className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}
